import lodash from "lodash"
import axiosOverlay from "../../js/axiosOverlay"
import distance from "../../js/geolocationTool"

const state = {
    entrees: null,
    allEntrees: null,
    selectedEntree: null
};

const getters = {
    entrees: state => state.entrees,
    allEntrees: state => state.allEntrees,
    selectedEntree: state => state.selectedEntree,
    getAllEntrees: (state) => {
        return state.allEntrees ? JSON.parse(state.allEntrees) : [];
    },
    getAllProgrammes: (state, getters) => {
        return [...new Set(getters.getAllEntrees.map(e=>e.programme))];
    },
    getEntreeByID: (state, getters) => (EntreeID) => {
        return getters.getAllEntrees.filter(entree => entree.id === EntreeID);
    },
    getEntreesByGeolocation: (state) => (currentLat, currentLong) => {
        if (!state.entrees) return [];
        let res = JSON.parse(state.entrees);
        res = res.map((entree) => {
            if (entree.gpsLatitude && entree.gpsLongitude) {
                entree.dist = distance(
                    entree.gpsLongitude,
                    entree.gpsLatitude,
                    currentLong,
                    currentLat
                );
            } else
                entree.dist = 999;
            return entree;
        });
        res = lodash.orderBy(res, ["dist"], ["asc"]);
        return res;
    },
    getAllCommunes: (state) => {
        if (!state.entrees) return [];
        let result = lodash.keys(lodash.countBy(JSON.parse(state.entrees).filter(entree => entree.enGestion), entree => entree.commune))
        return result
    },
    getQuartiersByCommune: (state) => (selectCommune) => {
        if (!state.entrees) return [];
        let entreesDeLaCommuneSelectionnee = JSON.parse(state.entrees).filter(entree => entree.commune === selectCommune && entree.enGestion)
        let result = lodash.keys(lodash.countBy(entreesDeLaCommuneSelectionnee, entree => entree.quartier))
        return result
    },
    getRueByQuartier: (state) => (selectQuartier) => {
        if (!state.entrees) return [];
        let entreesDuQuartierSelectionne = JSON.parse(state.entrees).filter(entree => entree.quartier === selectQuartier && entree.enGestion)
        let result = lodash.keys(lodash.countBy(entreesDuQuartierSelectionne, entree => entree.rue))
        return result
    },
    getEntreeByCommuneQuartierRue: (state) => (selectCommune, selectQuartier, selectRue) => {
        if (!state.entrees) return [];
        let entreesDeLaCommuneSelectionnee = JSON.parse(state.entrees).filter(entree => entree.commune === selectCommune && entree.enGestion)
        let entreesDuQuartierSelectionne = entreesDeLaCommuneSelectionnee.filter(entree => entree.quartier === selectQuartier)
        let entreesDeLaRueSelectionnee = entreesDuQuartierSelectionne.filter(entree => entree.rue === selectRue)
        return entreesDeLaRueSelectionnee
    }
};

const mutations = {
    SET_ENTREES(state, entrees) {
        state.entrees = entrees;
    },
    SET_ALL_ENTREES(state, allEntrees) {
        state.allEntrees = allEntrees;
    },
    SET_SELECTED_ENTREE(state, entreeID) {
        state.selectedEntree = entreeID;
    }
};

const actions = {
    async checkIfEntreeExistAPI(_, idEntree) {
        let config = {
            method: 'get',
            url: process.env.VUE_APP_API_URL + "/entrees?id=" + idEntree,
            headers: {}
        };

        try {
            const response = await axiosOverlay(config);
            return JSON.stringify(response.data);
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    
    async loadAllEntreesFromAPI({ commit, state }, searchParamsEntree) {
        if (
            !state.allEntrees // Permet de ne charger les entrées que si elles sont absentes du store
            || [...new Set(JSON.parse(state.allEntrees).map(item => item.programme))].length < 2 // ou si le nombre de Programmes chargés à de 1 ou -
        ) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/entrees" + (searchParamsEntree ? "?programme=" + searchParamsEntree.programme : ""),
                headers: {}
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_ALL_ENTREES', result);
                
                if (searchParamsEntree) {
                    // Recharge l'ensemble des entrées pour compléter le premier appel
                    await this.dispatch('entrees/loadAllEntreesFromAPI');
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    
    loadEntreesFromPartnr({ commit, state }, Partnr) {
        // Retourne la liste des entrées gérées par le partenaire
        let entreesPartnr = JSON.parse(Partnr).map(p => p.entree)
        let allEntrees = JSON.parse(state.allEntrees);
        let filteredEntrees = JSON.stringify(
            allEntrees.filter(e => entreesPartnr.includes(e.id))
        );
        commit('SET_ENTREES', filteredEntrees);
    },
    
    setSelectedEntree({ commit }, entreeID) {
        commit('SET_SELECTED_ENTREE', entreeID);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
